export default __webpack_public_path__ + "static/media/1.46b0fa4e.jpg";